//all action types goes here

//action types for authentication
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const EMPTY_STATE = "EMPTY_STATE";

//action types for orders
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";

//store status

export const SET_STATUS_LOAD = "SET_STATUS_LOAD";
export const SET_STATUS_ERROR = "SET_STATUS_ERROR";
export const SET_STATUS_SUCCESS = "SET_STATUS_SUCCESS";
export const SET_STATUS_RESET = "SET_STATUS_RESET";

export const GET_STATUS_LOAD = "GET_STATUS_LOAD";
export const GET_STATUS_ERROR = "GET_STATUS_ERROR";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";

//menu constants

//get all menu from POS
export const GET_ALL_MENU_LOAD = "GET_ALL_MENU_LOAD";
export const GET_ALL_MENU_SUCCESS = "GET_ALL_MENU_SUCCESS";
export const GET_ALL_MENU_ERROR = "GET_ALL_MENU_ERROR";

//bulk upload

export const BULK_UPLOAD_LOADING = "BULL_UPLOAD_LOADING";
export const BULK_UPLOAD_SUCCESS = "BULL_UPLOAD_SUCCESS";
export const BULK_UPLOAD_ERROR = "BULL_UPLOAD_ERROR";
export const BULK_UPLOAD_RESET = "BULL_UPLOAD_RESET";

//bulk upload partner

export const BULK_UPLOAD_LOADING_PARTNER = "BULL_UPLOAD_LOADING_PARTNER";
export const BULK_UPLOAD_SUCCESS_PARTNER = "BULL_UPLOAD_SUCCESS_PARTNER";
export const BULK_UPLOAD_ERROR_PARTNER = "BULL_UPLOAD_ERROR_PARTNER";
export const BULK_UPLOAD_RESET_PARTNER = "BULL_UPLOAD_RESET_PARTNER";

//update menu item

export const UPDATE_ITEM_LOAD = "UPDATE_ITEM_LOAD";
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const UPDATE_ITEM_ERROR = "UPDATE_ITEM_ERROR";
export const UPDATE_ITEM_RESET = "UPDATE_ITEM_RESET";

//sales items

export const ADD_SALES_ITEM_LOAD = "ADD_SALES_ITEM_LOAD";
export const ADD_SALES_ITEM_SUCCESS = "ADD_SALES_ITEM_SUCCESS";
export const ADD_SALES_ITEM_ERROR = "ADD_SALES_ITEM_ERROR";

export const GET_SALES_ITEMS_LOAD = "GET_SALES_ITEMS_LOAD";
export const GET_SALES_ITEMS_SUCCESS = "GET_SALES_ITEMS_SUCCESS";
export const GET_SALES_ITEMS_ERROR = "GET_SALES_ITEMS_ERROR";

export const ADD_TO_TICKETS = "ADD_TO_TICKETS";
export const REMOVE_FROM_TICKETS = "REMOVE_FROM_TICKETS";

//sales new
export const ADD = "ADD";
export const REMOVE = "REMOVE";
export const RESET = "RESET";

export const INCREASE = "INCREASE";
export const DECREASE = "DECREASE";

export const ADD_TOTAL = "ADD_TOTAL";
export const ORDER_TYPE = "ORDER_TYPE";

export const DISCOUNT_TYPE = "DISCOUNT_TYPE";
export const DISCOUNT_AMOUNT = "DISCOUNT AMOUNT";
